angular.module('bbl.directives.ng-clip', [])
.directive('ngClip', ['Toast', function(Toast) {
	return {
		restrict: 'EA',
		link: function($scope, $el, atts) {
			var clipboard = new Clipboard($el[0]);

			clipboard.on('success', function(e) {
				var copy = e.text.length > 25 ? (e.text.slice(0, 25)+'...') : e.text,
					msg = '<strong><code>'+copy+'</code></strong> copied to clipboard!';

				Toast.notify(atts.ngCpSuccess || msg, {duration: atts.ngClip || 5000});

				e.clearSelection();
			});

			clipboard.on('error', function(e) {
				console.error('Action:', e.action);
				console.error('Trigger:', e.trigger);
			});
		}
	};
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/ng-clip.js
 ** module id = 168
 ** module chunks = 0
 **/